module.exports = __webpack_public_path__ + "static/media/search-solid.c6a0effb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/search-solid.svg
// module id = 1283
// module chunks = 0